import {Component} from "@angular/core";
import {ActivatedRoute, Params} from "@angular/router";

import {ERROR} from '../shared/constant/error.constant';

@Component({
  selector: 'error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})

export class ErrorComponent {

  errorType: string;
  errorReference: string;

  constructor(private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.route.params
      .forEach((params: Params) => {
        this.errorType = params['errorType'];
      });

    this.route.queryParams
      .forEach((params: Params) => {
        this.errorReference = this.getErrorReference(params);
      });

  }

  // SLACKERS-595: surface the underlying failure so a screenshot of this page is
  // enough to identify what actually broke. See HttpService.handleError.
  getErrorReference(params: Params): string {
    const status = params['status'];
    const kind = params['kind'];

    if (!status && !kind) {
      return null;
    }

    return [kind, status ? `status ${status}` : null].filter(part => !!part).join(' ');
  }

  getErrorMsg() {
    switch (this.errorType) {
      case ERROR.ACCESS_DENIED.type :
        return ERROR.ACCESS_DENIED.msg;
      case ERROR.SERVICE_UNAVAILABLE.type :
        return ERROR.SERVICE_UNAVAILABLE.msg;
      case ERROR.NOT_FOUND.type :
        return ERROR.NOT_FOUND.msg;
      default :
        return ERROR.UNKNOWN.msg;
    }

  }

}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/error/error.component.ts